import { Button } from '@/shared/components/ui';
import { WithdrawModalTotalSection } from './WithdrawModalTotalSection';

type WithdrawFooterProps = {
  amount: number;
  assetCode: string;
  withdrawFee: number;
  precision: number;
  includeFee: boolean;
  disabled?: boolean;
  isLoading: boolean;
  onSubmit: () => void;
  submitLabel: string;
};

export function WithdrawModalFooter({
  amount,
  assetCode,
  withdrawFee,
  includeFee,
  disabled = false,
  isLoading,
  onSubmit,
  submitLabel,
  precision,
}: WithdrawFooterProps) {
  return (
    <div className="grid gap-[1.6rem] w-full grid-cols-2 pt-[1.6rem] border-t border-border sm:px-[3.2rem] px-[2.4rem]">
      <WithdrawModalTotalSection
        amount={amount}
        assetCode={assetCode}
        fee={withdrawFee}
        includeFee={includeFee}
        precision={precision}
      />
      <div className="w-full flex items-center">
        <Button
          variant="default"
          className="headline4 px-[3.2rem] py-[1.6rem] rounded-[1.2rem] w-full"
          onClick={onSubmit}
          disabled={disabled}
          loading={isLoading}>
          {submitLabel}
        </Button>
      </div>
    </div>
  );
}
